import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FileSystemFileEntry, UploadEvent } from "ngx-file-drop";
import { Photo } from "../../../../shared/models/cameralla-photo.model";
import { UploadService } from "../../service/upload.service";
import { ToastrService } from "ngx-toastr";
import * as EXIF from "../../../../shared/modified_modules/exif-js";
import { PhotoService } from "../../../photo/services/photo.service";
import { UploadComponent } from "../upload/upload.component";

@Component({
    selector: 'app-photo-related',
    templateUrl: './photo-related.component.html'
})

export class PhotoRelatedComponent implements OnInit, OnDestroy {
    @Input() userId;
    @Input() newPhotoSize;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    @Input() photoRelatedURL;

    photoRelated: Photo;
    file: File;
    fileList: FileList;

    constructor(public activeModal: NgbActiveModal,
                private toastr: ToastrService,
                private photoService: PhotoService,
                private service: UploadService,) {
        this.photoRelated = new Photo();
    }

    ngOnInit() {
    }

    public dropped(event: UploadEvent) {
        if (event.files) {
            const droppedFile = event.files[0];

            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

                fileEntry.file((file: File) => {
                    if (this.service.fileTypes.indexOf(file.type) + 1) {
                        this.file = file;
                        this.setLocalPreview(this.file);
                    } else {
                        this.toastr.error('Files not allowed', 'Error');
                    }
                });
            } else {
                this.toastr.error('Only one file can be dropped', 'Error');
            }
        }
    }

    public setLocalPreview(file: File) {
        const me = this;
        const defaultModel = {
            model: 'Canon EOS 1D X Mark II',
            lens: '50mm f1.8',
            aperture: '2.2',
            ISO: '300',
            shutterSpeed: '1/1600',
            focalLength: '24'
        };

        if (file.size < UploadComponent.maxFileSize) {
            EXIF.getData(file, function () {
                const allMetaData = EXIF.getAllTags(this);

                if (allMetaData) {
                    me.photoRelated.model = allMetaData.Model || defaultModel.model;
                    me.photoRelated.lens = allMetaData.FocalLength ? me.service.roundExif(allMetaData.FocalLength.numerator, allMetaData.FocalLength.denominator) + 'mm ' : '';
                    me.photoRelated.lens += allMetaData.FNumber ? 'f/' + me.service.roundExif(allMetaData.FNumber.numerator, allMetaData.FNumber.denominator) : defaultModel.lens;
                    me.photoRelated.aperture = allMetaData.FNumber ? me.service.roundExif(allMetaData.FNumber.numerator, allMetaData.FNumber.denominator) : defaultModel.aperture;
                    me.photoRelated.ISO = allMetaData.ISOSpeedRatings || defaultModel.ISO;
                    me.photoRelated.shutterSpeed = allMetaData.ExposureTime ? allMetaData.ExposureTime.numerator + '/' + allMetaData.ExposureTime.denominator : defaultModel.shutterSpeed;
                    me.photoRelated.focalLength = allMetaData.FocalLength ? me.service.roundExif(allMetaData.FocalLength.numerator, allMetaData.FocalLength.denominator) : defaultModel.focalLength;
                }
            });

            const reader = new FileReader();
            const image = new Image();

            reader.readAsDataURL(file);

            reader.onload = () => {
                image.src = reader.result;
                image.onload = rs => {
                    // if (rs.currentTarget['width'] && rs.currentTarget['height']) {
                    //     //Default Width: 800
                    //     file['width'] = 800;
                    //     file['height'] = AppShareHelper.resize(rs.currentTarget['width'], rs.currentTarget['height']);
                    // }
                    //
                    // if ((file['height'] === this.newPhotoSize.height) && (file['width'] === this.newPhotoSize.width)) {
                    //     this.photoRelated.localURL = image.src;
                    //     file['wasRelated'] = true;
                    //     this.passEntry.emit(file);
                    // } else {
                    //     file['wasRelated'] = ""
                    //     this.remove(true);
                    // }
                    this.photoRelated.localURL = image.src;
                    file['wasRelated'] = true;
                    this.passEntry.emit(file);
                }
            };
        } else {
            this.toastr.error('Max file size exceeds 50MB', 'Error');
        }
    }

    public fileChange(event) {
        this.fileList = event.target.files;

        if (this.fileList.length > 0) {
            if (this.service.fileTypes.indexOf(this.fileList[0].type) + 1) {
                this.file = this.fileList[0];
                this.setLocalPreview(this.file);
            } else {
                this.toastr.error('File type not allowed', 'Error');
            }
        }
    }

    remove(showWarning?) {
        this.photoRelated = new Photo();

        // For edit case
        if (this.photoRelatedURL) {
            this.photoRelatedURL = null;
        }

        this.passEntry.emit({
            remove: true
        })
        if (showWarning) {
            this.toastr.warning(`Please select the related photo with the same dimension: (${this.newPhotoSize.width} x ${this.newPhotoSize.height})`, 'Warning');
        }
    }

    ngOnDestroy() {
    }
}
